import { SeoMeta, useSeo } from '@web/library/use-seo';
import { AnyObject, Props } from 'shared/@types';
import Layout from '@web/components/layout';
import { View } from 'react-native';

export const Page = ({
  children,
  CustomLayout,
  register,
  ...props
}: Props<
  {
    CustomLayout?: any;
    register: (builder: SeoMeta) => SeoMeta;
  } & AnyObject
>) => {
  const builder = useSeo();

  const Component = (
    <View accessibilityRole={'main' as any} className="!static z-auto flex-1">
      {register(builder).generateTags()}

      {children}
    </View>
  );

  if (CustomLayout) {
    return <CustomLayout {...props}>{Component}</CustomLayout>;
  } else {
    return <Layout {...props}>{Component}</Layout>;
  }
};
